import React from 'react';
import { motion } from 'framer-motion';
import { Droplet, Heart, Users, BookOpen, Sparkles } from 'lucide-react';
import { Button } from "@/components/ui/button";

const CATEGORIES = [
  { 
    id: 'all', 
    label: 'Todo', 
    icon: Sparkles,
    color: 'from-purple-500 to-pink-500',
    bg: 'bg-purple-50',
    text: 'text-purple-700'
  },
  { 
    id: 'diabetes', 
    label: 'Diabetes', 
    icon: Droplet,
    color: 'from-blue-500 to-cyan-500',
    bg: 'bg-blue-50',
    text: 'text-blue-700'
  },
  { 
    id: 'hipertension', 
    label: 'Hipertensión', 
    icon: Heart,
    color: 'from-red-500 to-rose-500',
    bg: 'bg-red-50',
    text: 'text-red-700'
  },
  { 
    id: 'alimentacion_familiar', 
    label: 'Alimentación Familiar', 
    icon: Users,
    color: 'from-orange-500 to-amber-500',
    bg: 'bg-orange-50',
    text: 'text-orange-700'
  },
  { 
    id: 'lectura_etiquetas', 
    label: 'Lectura de Etiquetas', 
    icon: BookOpen,
    color: 'from-emerald-500 to-teal-500',
    bg: 'bg-emerald-50',
    text: 'text-emerald-700'
  },
];

export default function CategoryFilter({ selectedCategory, onSelectCategory }) {
  return (
    <div className="overflow-x-auto pb-2 -mx-3 px-3 sm:-mx-4 sm:px-4" style={{ WebkitOverflowScrolling: 'touch' }}>
      <div className="flex gap-2 min-w-max">
        {CATEGORIES.map((category) => {
          const Icon = category.icon;
          const isSelected = selectedCategory === category.id;
          
          return (
            <motion.button
              key={category.id}
              whileTap={{ scale: 0.95 }}
              onClick={() => onSelectCategory(category.id)}
              className={`
                relative flex items-center gap-1.5 px-3 py-2 rounded-xl border-2 transition-all font-medium text-xs sm:text-sm whitespace-nowrap
                ${isSelected 
                  ? `${category.bg} border-transparent shadow-md` 
                  : 'bg-white border-gray-200 hover:border-gray-300'
                }
              `}
            >
              {isSelected && (
                <motion.div
                  layoutId="activeCategory"
                  className={`absolute inset-0 bg-gradient-to-r ${category.color} opacity-10 rounded-xl`}
                  transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
                />
              )}
              <Icon className={`w-4 h-4 relative z-10 ${isSelected ? category.text : 'text-gray-400'}`} />
              <span className={`relative z-10 ${isSelected ? category.text : 'text-gray-600'}`}>
                {category.label}
              </span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}